import TitlePart from "./TitlePart";

export default function FooterMenu({ menu }) {
  return (
    <div className="footer-menu">
      <div className="container">
        <div className="grid grid-cols-mobile gap-x-mobile xs:grid-cols-normal md:gap-x-normal">
          <div className="col-span-2 xs:col-span-10 xs:col-start-2 sm:col-span-8 sm:col-start-3 lg:col-span-12">
            {menu.map((item) => (
              <TitlePart key={item?.node?.id} menuPart={item} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}